<div [id]="id" class="tag-dropzone w-100" cdkDropList (cdkDropListDropped)="tagsDropAssign.drop($event)">
	@if(tags && tags.length) {
	<div class="py-1 d-flex gap-2 flex-row flex-wrap p-2">
		@for (tag of tags; track $index) {
		<div
			[style.background-color]="utils.getParameterByName(tag, 'colorCode')"
			[style.padding]="displayDeleteIcon === tag.id ? '5px' : '5px 20px'"
			class="tag-item d-flex align-items-center list-item"
			(mouseenter)="displayDeleteIcon = tag.id || ''"
			(mouseleave)="displayDeleteIcon = ''">
			<span [style.opacity]="displayDeleteIcon === tag.id ? '1' : '0.7'">
				{{ utils.getParameterByName(tag, 'value') }}
			</span>
			<div [@showHide]="displayDeleteIcon === tag.id ? 'show' : 'hide'">
				<button mat-icon-button type="button" aria-label="Remove data item" matTooltip="{{ 'BUTTON.REMOVE' | translate }}" matTooltipPosition="below" (click)="itemAction('REMOVE', tag)">
					<mat-icon>close</mat-icon>
				</button>
			</div>
		</div>
		}
	</div>
	} @else {
    <div class=" d-flex align-items-center justify-content-center h-100 mx-1 py-2">
      <span>{{ 'CLIPS.DRAG_TAG' | translate }}</span>
    </div>
	}
</div>
